import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';

export const telInput = () => {
    const input = document.querySelector("#signup_phone_number");
    
    if ( input ) {
        const options = {
            utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/18.2.1/js/utils.js',
            autoInsertDialCode: true,
            initialCountry: 'gb',
            preferredCountries: ['gb', 'us'],
        };
    
        const iti = intlTelInput(input, options);

        return iti;
    }
}